var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"content-box"}},[_c('el-header',{staticStyle:{"font-size":"12px"}},[_c('el-tabs',_vm._l((_vm.pageData),function(item){return _c('el-tab-pane',{key:item.id,attrs:{"label":item.name}},[_c(item.content,{tag:"component",attrs:{"itemData":item.data}})],1)}),1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e473a844","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sp/index.vue
// module id = null
// module chunks = 